import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminDocumentInfo from "../../../components/admin/document/AdminDocumentInfo";

//어드민 문서 상세 페이지
const AdminDocumentInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //문서 식별자가 없는 경우
    if (!id) {
        return <div>Invalid document ID</div>;
    }

    return (
        <AdminLayout>
            {/*문서 상세 정보*/}
            <AdminDocumentInfo documentId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminDocumentInfoPage;